import type { DropdownProps, MenuProps } from 'antd';
import { Avatar, Dropdown, Typography } from 'antd';
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthUser } from '@/hooks/useAuthUser';
import { useLogoutMutation } from '@/state/slices/auth';
import { performClientLogout } from '@/state/utils/authSession';
import styles from './UserDropdown.module.css';

const { Text } = Typography;

interface IProps {
  userFullName: string;
  userEmail?: string;
  userRole?: string;
}

export default function UserDropdown({ userFullName, userRole }: IProps) {
  const navigate = useNavigate();
  const { setUser } = useAuthUser();
  const [logoutFn] = useLogoutMutation();

  const handleLogout = () => {
    performClientLogout(logoutFn, setUser);
    navigate('/login');
  };

  const handleSettings = () => {
    navigate('/settings');
  };

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'settings') {
      handleSettings();
    } else if (key === 'logout') {
      handleLogout();
    }
  };

  const items: MenuProps['items'] = [
    // TODO: Uncomment to enable admin permission validation
    // ...(user.role === 'admin'
    //   ? [
    //       {
    //         key: 'settings',
    //         label: 'Settings',
    //         icon: <SettingOutlined />,
    //       },
    //       {
    //         type: 'divider' as const,
    //       },
    //     ]
    //   : []),
    {
      key: 'settings',
      label: 'Settings',
      icon: <SettingOutlined />,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Sign out',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  const sharedProps: DropdownProps = {
    menu: { items, onClick: handleMenuClick },
    placement: 'bottomRight',
  };

  return (
    <Dropdown {...sharedProps} trigger={['click']}>
      <div className={styles.trigger}>
        <Avatar
          size={28}
          icon={<UserOutlined />}
          style={{ backgroundColor: '#1890ff' }}
        />
        <div className={styles.userInfo}>
          <Text className={styles.userName}>{userFullName}</Text>
          {userRole && <Text className={styles.userRole}>{userRole}</Text>}
        </div>
      </div>
    </Dropdown>
  );
}
